import { StyleProp, TextStyle, ViewStyle } from "react-native";
import { Container } from "../../../../shared/types";
import { style as lookCollageStyle } from "./LookCollage.style";

const getAspectRatioByContainer = (container: Container): number => {
  if (container === Container.CONTAINER_1) {
    return 5 / 4;
  }
  if (container === Container.CONTAINER_2) {
    return 2;
  }
  if (container === Container.CONTAINER_3) {
    return 0.75;
  }
  if (container === Container.CONTAINER_4) {
    return 1;
  }
  if (container === Container.CONTAINER_5) {
    return 1.6;
  }
  return 1;
};

const getPaddingStyleByContainer = (container: Container): StyleProp<ViewStyle | TextStyle> => {
  const style = lookCollageStyle();

  if (container === Container.CONTAINER_1) {
    return style.paddingContainer1;
  }
  if (container === Container.CONTAINER_2) {
    return style.paddingContainer2;
  }
  if (container === Container.CONTAINER_3) {
    return style.paddingContainer3;
  }
  if (container === Container.CONTAINER_4) {
    return style.paddingContainer4;
  }
  if (container === Container.CONTAINER_5) {
    return style.paddingContainer5;
  }
  return style.paddingDefault;
};

export { getAspectRatioByContainer, getPaddingStyleByContainer };
